const initialState = {
	loading: false,
	items: [],
	// which list (see listNonNormalItems) items holds
	listKey: null,
	// the last refresh was rate limited, so items may be out of date
	listStale: false,
};

export default function archiveReducer(state = initialState, action) {
	switch (action.type) {
		case "GET_NON_NORMAL_ITEMS_REQUEST":
			return { ...state, loading: true };
		case "GET_NON_NORMAL_ITEMS_SUCCESS":
			return {
				loading: false,
				items: action.payload.items,
				listKey: action.payload.listKey,
				listStale: false,
			};
		case "GET_NON_NORMAL_ITEMS_FAILURE": {
			const { rateLimited, listKey } = action.payload;
			// only a rate limited refresh of the same list keeps its items
			const keepItems = rateLimited && listKey === state.listKey;
			return {
				loading: false,
				items: keepItems ? state.items : [],
				listKey: keepItems ? state.listKey : null,
				listStale: rateLimited,
			};
		}
		default:
			return state;
	}
}
